import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { useTranslation } from "react-i18next";
import { useMobileNav } from "../context/MobileNavContext";
import {
  getMainNavItems,
  NavRail, NavRailItem,
  MobileNavDrawer, MobileNavItem,
} from "./ui";
import { isSuperAdminProfile } from "../utils/tenantSubdomain";


const Sidebar = ({ profile, className }) => {
  const { t } = useTranslation();
  const { role } = profile || {};
  const { isOpen, closeNav } = useMobileNav();

  const items = getMainNavItems(t, role, { isSuperAdmin: isSuperAdminProfile(profile) });
  const desktopMain = items.filter((i) => i.placement === "main");
  const footerItems = items.filter((i) => i.placement === "footer");
  const mobileItems = items.filter((i) => i.placement !== "footer");

  return (
    <>
      <NavRail
        className={className}
        footer={
          footerItems.map((item) => (
            <NavRailItem
              key={item.to}
              to={item.to}
              label={item.label}
              icon={item.icon}
              exact={item.exact}
              linkState={item.linkState}
              extraPaths={item.extraPaths}
            />
          ))
        }
      >
        {desktopMain.map((item) => (
          <NavRailItem
            key={item.to}
            to={item.to}
            label={item.label}
            icon={item.icon}
            exact={item.exact}
            linkState={item.linkState}
            extraPaths={item.extraPaths}
          />
        ))}
      </NavRail>

      <MobileNavDrawer
        open={isOpen}
        onClose={closeNav}
        closeLabel={t("topBar.closeMenu")}
        title={t("app.name")}
        className={className}
      >
        {mobileItems.map((item) => (
          <MobileNavItem
            key={item.to}
            to={item.to}
            label={item.label}
            icon={item.icon}
            exact={item.exact}
            linkState={item.linkState}
            extraPaths={item.extraPaths}
            onClick={closeNav}
          />
        ))}
        {footerItems.map((item) => (
          <MobileNavItem
            key={item.to}
            to={item.to}
            label={item.label}
            icon={item.icon}
            exact={item.exact}
            linkState={item.linkState}
            extraPaths={item.extraPaths}
            onClick={closeNav}
          />
        ))}
      </MobileNavDrawer>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile.profile,
});

export default compose(connect(mapStateToProps))(Sidebar);
